// extracted by mini-css-extract-plugin
export default {"title":"da47a7c2bb","inner_title":"c47582d6ed","charge_btn":"_7a428694c2"};